import { Row } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const Menu = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const currentPath = location.pathname;

    return (
        <Row className="menu">
            <div
                className={`item ${currentPath === "/" ? "active" : ""}`}
                onClick={() => navigate("/")}
            >
                <span>Home</span>
                <i className="fa-solid fa-house"></i>
            </div>
             <div
                className={`item ${currentPath === "/report" ? "active" : ""}`}
                onClick={() => navigate("/report")}
            >
                <span>Timesheets</span>
                <i className="fa-solid fa-square-poll-horizontal"></i>
            </div>
           <div
                className={`item ${currentPath === "/leave" ? "active" : ""}`}
                onClick={() => navigate("/leave")}
            >
                <span>Leave</span>
                <i className="fa-solid fa-plane"></i>
            </div>
            <div
                className={`item ${currentPath === "/profile" ? "active" : ""}`}
                onClick={() => navigate("/profile")}
            >
                <span>Profile</span>
                <i className="fa-solid fa-user"></i>
            </div>
        </Row>
    );
};

export default Menu;